import $ from "jquery";
import modalUpdate from './modal-update.js';
import popupLink from './components/popup-link.js';
import convertToHalfWidth, { convertHalf } from './convert-half-with.js';
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
var define = {
  confirm_withdrawal: "退会するとこれまでのデータはすべて削除されます。本当に退会しますか？"
};

//const obj = $.parseJSON(attributes);

var expertError = {
  errorFields: function (field, message) {
    $("." + field)
      .show()
      .text(message);
  },
  hideFields: function (field) {
    $("." + field).hide();
  },
  getDataField: function (field) {
    let class_field = $("." + field);
    let field_data = [];
    class_field.each(function () {
      if (this.checked == true) {
        field_data.push(this.defaultValue);
      }
    });
    return field_data;
  },
  scrollTop: function () {
    $(window).scrollTop(0);
  },
};

$(document).ready(function () {
  // Convert Half size
  $('input[name="transfer_holder_kana"]').on("change", function () {
    $(this).val(convertToHalfWidth($(this).val()));
  });
  $('input[name="company_name_kana"]').on("change", function () {
    $(this).val(convertToHalfWidth($(this).val()));
  });
  $('input[name="first_name_kana"]').on("change", function () {
    $(this).val(convertToHalfWidth($(this).val()));
  });
  $('input[name="last_name_kana"]').on("change", function () {
    $(this).val(convertToHalfWidth($(this).val()));
  });

  $(".convertHalf").on("keyup", function (event) {
    if (event.keyCode == 13) {
      convertHalf($(this), event);
      AjaxZip3.zip2addr("zip[0]", "zip[1]", "pref", "city", "address");
    }
  });

  $(".convertHalf").on("change", function (event) {
    convertHalf($(this), event);
    AjaxZip3.zip2addr("zip[0]", "zip[1]", "pref", "city", "address");
  });

  $(".convertHalf").keydown(function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 110, 190, 188, 229]) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  });
  $('select[name="pref_can_work"]').on("change", function () {
    $("input[name='area_can_work']").each(function (i) {
      $(this).prop("checked", false);
    });
  });
  $('input[name="area_can_work"]').on("change", function () {
    $('select[name="pref_can_work"]').val("");
  });
  $('input[name="job_status"]').on("change", function () {
    let disabled = false;
    if($(this).val() == 1) {
      disabled = true;
    }
    $('#jsBoxAddChildIdExport').find(':input').prop('disabled', disabled)
  });

  $('input[name="area_can_work"]').on("change", function () {
    let disabled = false;
    if($(this).val() > 1) {
      disabled = true;
    }
    var numPref = $('.prefCanWork').length
    for (var i = 1; i <= numPref; i++) {
      $('#pref_can_work'+i).prop('disabled', disabled);
    }
  });

  $('body').on('click', '.linkManagement', function(){
    window.location = $(this).data('link');
  })
  $('body').on('click', '.linkSubmit', function(){
    window.location = $(this).data('link');
  })
  $('body').on('click', '.linkDecided', function(){
    window.location = $(this).data('link');
  })

  $('body').on('click', '.checkDataCSV', function(e){
    e.preventDefault();
    let csv_file = $('input[name=csv_file]').val();
    if(!csv_file) {
      alert("登録用のCSVをアップロードしてください。");
      return false;
    }
    let url = $(this).attr("data-action");
    let _token = $('meta[name="csrf-token"]').attr("content");
    let inputs = {};
    inputs['id'] = $(this).attr("data-id");
    inputs['screen'] = $(this).attr("data-screen");
    inputs['csv_file'] = csv_file
    return $.ajax({
      url: url,
      data: inputs,
      type: 'POST',
      dataType: "json",
      beforeSend: function () {
        $(this).prop("disabled", true);
      },
    }).done(function (res) {
      if(res.status == 'not_data') {
        alert('CSVの内容を入力してください。');
        location.reload();
      }
      if(res.status == 'maxline') {
        let html = '<p style="color:red; font-weight: bold">1,000件以上アップロードしないでください。</p>';
        $("#resultImport").html(html);
      }
      if(res.status == 'notformat') {
        let html = '<p style="color:red; font-weight: bold">CSVファイルの1行目に記載されていた項目のテキストは編集しないでください。</p>';
        $("#resultImport").html(html);
      } else {
        $("#resultImport").html(res.html);
        if(res.status == false) {
          $(this).removeAttr("disabled");
          $("#saveImportDataCSV").attr("data-submit", false);
          $("#saveImportDataCSV").attr("data-error", true);
        } else if(res.status == true) {
          $("#saveImportDataCSV").attr("data-submit", true);
        } else {
          if(res.status != 'select_file') {
            location.reload();
          }
        }
      }
    });
  })

  $('body').on('click', '#saveImportDataCSV', function(e){
    e.preventDefault();
    let csv_file = $('input[name=csv_file]').val();
    if(!csv_file) {
      alert("登録用のCSVをアップロードしてください。");
      return false;
    }
    if($(this).attr("data-submit") == 'false' && $(this).attr("data-error") == 'false') {
      if($(this).attr("data-screen") == 'register') {
        alert('CSVをアップロードした後「CSVの内容を確認する」をクリックしてください。\n内容を確認後「この内容で登録する」をクリックして登録してください');
      } else {
        alert('CSVをアップロードした後「CSVの内容を確認する」をクリックしてください。\n内容を確認後「この内容で招待する」をクリックして招待してください');
      }
      return false;
    } if($(this).attr("data-submit") == 'false' && $(this).attr("data-error") == 'true') {
      alert('CSVの内容にはエラーが発生いたしました。\n下記のエラーメッセージを確認していただき、もう一度アップロードをお願いいたします。')
    } else {
      let url = $(this).attr("data-action");
      let _token = $('meta[name="csrf-token"]').attr("content");
      let inputs = {};
      inputs['id'] = $(this).attr("data-id");
      inputs['screen'] = $(this).attr("data-screen");
      inputs['csv_file'] = csv_file
      inputs['submit'] = $(this).attr("data-submit");
      return $.ajax({
        url: url,
        data: inputs,
        type: 'POST',
        dataType: "json",
        beforeSend: function () {
          $("#saveImportDataCSV").prop("disabled", true);
        },
      }).done(function (res) {
        $("#saveImportDataCSV").removeAttr("disabled");
        if(res.status == true) {
          alert(res.message);
          window.location = redirect_url;
        } else {
          location.reload();
        }
      });
    }
  })

  $('body').on('click', '#processIsCancel', function(e){
    e.preventDefault();
    if (confirm("本当にキャンセルしてもよろしいですか。")) {
      if(!$(this).attr("data-id")) {
        alert('キャンセルしたいメンバーを選択してください。')
      }
      let url = $(this).attr("data-action");
      let _token = $('meta[name="csrf-token"]').attr("content");
      let inputs = {};
      const blocks = document.querySelectorAll(".jsInputCheck");
      var checked_values = [];
      if (blocks) {
        blocks.forEach(block => {
          const checkItems = block.querySelectorAll('.checkItem');
          checkItems.forEach(checkItem => {
            if(checkItem.checked) {
              checked_values.push(checkItem.value);
            }
          })
        })
      }
      if(checked_values.length > 0) {
        inputs['company_id'] = $(this).attr("data-id");
        inputs['id'] = checked_values;
        return $.ajax({
          url: url,
          data: inputs,
          type: 'POST',
          dataType: "json",
          beforeSend: function () {
            //$(this).attr("disabled", "disabled");
          },
        }).done(function (res) {
          if(res.status == true) {
            alert('メンバーの招待をキャンセルしました。')
          }
          location.reload();
        });
      } else {
        alert("キャンセルしたいメンバーを選択してください。")
      }
    }
  })
});

$('body').on('click', '.btnUpdate', function(){
  expertError.scrollTop();
})

// Expert Update my Personal
$("body").on("submit", "#frmExpertPersonal", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertPersonal");
});

// Expert Update my Company
$("body").on("submit", "#frmExpertCompany", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertCompany");
});

// Expert Update my Partner
$("body").on("submit", "#frmExpertPartner", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertPartner");
});

// Expert Update Profile mypage Personal
$("body").on("submit", "#frmExpertProfilePersonal", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertProfilePersonal");
});

// Expert Update Profile mypage Company
$("body").on("submit", "#frmExpertProfileCompany", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertProfileCompany");
});

// Expert Update Profile mypage Partner
$("body").on("submit", "#frmExpertProfilePartner", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmExpertProfilePartner");
});

// Expert Update Skill Achievement
$("body").on("submit", "#frmSkillAchievement", function (pre) {
  pre.preventDefault();
  return callApiCallback("frmSkillAchievement");
});

// Expert Update Career
$("body").on("submit", "#frmCareer", function (e) {
  e.preventDefault();
  return callApiCallback("frmCareer", "Career");
});

// Expert Update Desired
$("body").on("submit", "#frmDesired", function (pre) {
  pre.preventDefault();
  return callApiCallback('frmDesired');
});

// Company register expert
$("body").on("submit", "#frmEndividualRegistor", function (pre) {
  pre.preventDefault();
  return callApiCallback('frmEndividualRegistor');
});

// Company delete expert
$("body").on("click", ".frmDeleteItem", function (pre) {
  pre.preventDefault();
  let id = $(this).attr("data-id");
  let inputs = {};
  inputs['id'] = id;
  inputs['_token'] = $('meta[name="csrf-token"]').attr("content");
  $.ajax({
    url: $(this).attr("data-url-check-delete"),
    data: inputs,
    dataType: 'json',
    success: function(data){
      if (data.status == 'success') {
        if (confirm("本当に削除してもよろしいですか？")) {
          let url = $("#frmDeleteItem"+id).attr("action");
          let method = $("#frmDeleteItem"+id).attr("method");
          return $.ajax({
            url: url,
            data: inputs,
            type: method,
            dataType: "json",
            beforeSend: function () {
            },
          }).done(function (res) {
            if(res.status == true) {
              $('#parent_id'+id).remove();
            } else if(res.status == 'error') {
              alert('選択したエキスパートは削除できません。\n選択したエキスパートの「直接依頼された案件」、「応募中の案件」を辞退（見送り）したうえで削除してください。');
            } else {
              location.reload();
            }
          });
        }
      } else {
        alert('選択したエキスパートは削除できません。\n選択したエキスパートの「直接依頼された案件」、「応募中の案件」を辞退（見送り）したうえで削除してください。');
      }
    }
});

});

// Company delete expert
$("body").on("click", ".frmDeleteExpert", function (pre) {
  pre.preventDefault();
  let inputs = {};
  let id = $(this).attr("data-id");
  inputs['id'] = id;
  let url = $("#frmDeleteExpert"+id).attr("action");
  let method = $("#frmDeleteExpert"+id).attr("method");
  inputs['_token'] = $('meta[name="csrf-token"]').attr("content");
  return $.ajax({
    url: url,
    data: inputs,
    type: method,
    dataType: "json",
    beforeSend: function () {
      $(this).attr("disabled", "disabled");
    },
  }).done(function (res) {
    $(this).removeAttr("disabled");
    if(res.status == true) {
      window.location = redirect_url
    }
  });
});

window.callApiCallback = function(divIds, flag = '') {
  let inputs = {};
  if(flag == 'Career') {
    let number = document.getElementById("number_row").value;
    for (var k = 0; k <= number; k++) {
      var radio = Array.from(
        document.querySelectorAll("#radioList" + k + " input")
      );
      var value =
        radio.length &&
        radio.find((r) => r.checked) &&
        radio.find((r) => r.checked).value;
      if (value == undefined) {
        inputs["recruitment_form[" + k + "]"] = "";
      }
    }
  }
  let url = $("#"+divIds).attr("action");
  if(url == "#") {
    alert('プロフィール編集にて「プロフィール」、「スキル・実績」の必須事項を入力してください。');
    location.reload();
  }
  let method = $("#"+divIds).attr("method");
  let _token = $('meta[name="csrf-token"]').attr("content");
  let submit = $("input[name='submit']").val();
  let input_serialized = $("#"+divIds).serializeArray();
  input_serialized.forEach((field) => {
    inputs[field.name] = field.value;
  });
  return $.ajax({
    url: url,
    data: inputs,
    type: method,
    dataType: "json",
    beforeSend: function () {
      if(divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal' || divIds == 'frmExpertPartner') {
        $("#"+divIds+" .button2").attr("disabled", "disabled");
      } else {
        $("#"+divIds+" .btnSign01").attr("disabled", "disabled");
      }
      if (submit && submit == 'done' && (divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal')) {
        $("#"+divIds+" .button7").attr("disabled", "disabled");
      }
    },
  }).done(function (res) {
    if(divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal' || divIds == 'frmExpertPartner') {
      $("#"+divIds+" .button2").removeAttr("disabled");
    } else {
      $("#"+divIds+" .btnSign01").removeAttr("disabled");
    }
    if (submit && submit == 'done' && (divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal')) {
      $("#"+divIds+" .button7").removeAttr("disabled");
    }
    // TODO form export cty register expert personal
    $("#"+divIds+" .textError").css('display', 'none');
    // Status 419
    if((divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal') && (res.status == false && res.status_code == 419)) {
      location.reload();
    }

    if (divIds == 'frmExpertPersonal') {
      if (res.is_cancel) {
        window.location.href = '/';
        return;
      }
    }

    switch (res.status) {
      case "error":
        expertError.scrollTop();
        if(divIds == 'frmExpertProfilePersonal' || divIds == 'frmExpertProfileCompany' || divIds == 'frmSkillAchievement') {
          let html = "";
          $.each(res.message, function (key, value) {
            if(key == 'email') {
              value = value.slice(0,1).pop()
            }
            html += "<p class='noteError2'>"+value+"</p>";
            //case show error when text error have html <br> on filed transfer_account_number
            if(key == 'transfer_account_number' && value) {
              if (/<br>/.exec(value)) {
                value  = value[0].replace('<br>', '\n');
              }
            }
            expertError.errorFields(key, value);
          });
          
          if(html) {
            $( "#"+divIds+ " .noteErrorBox" ).html(html);

            //Add smooth scrolling to error message
            const box = document.getElementById('jsNoteErrorBox');
            const header = document.getElementById('header');
            if(box && header){
              const headerHeight = header.offsetHeight;
              const offTop = box.offsetTop - headerHeight - 10;
              $('body, html').stop().animate({scrollTop:offTop}, 500);
            }
            //End smooth scrolling
          }
        } else {
          $.each(res.message, function (key, value) {
            if(flag == 'Career') {
              let keys = key.replace(".", "");
              expertError.errorFields(keys, value);
            } else {
              if(key == 'email') {
                value = value.slice(0,1).pop()
              }
              expertError.errorFields(key, value);
            }
          });
        }
        break;
      case "confirm":
        expertError.scrollTop();
        if(divIds == 'frmExpertCompany') {
          expertResetHideHtmlCompany();
          insertAdjacentHTMLDataCompany(res);
        } else if (divIds == 'frmExpertPersonal'){
          expertResetHideHtmlPersonal();
          insertAdjacentHTMLDataPersonal(res)
        } else if (divIds == 'frmExpertPartner'){
          expertResetHideHtmlPartner();
          insertAdjacentHTMLDataPartner(res)
        }
        break;
      case "reload":
        location.reload();
        break;
      case "reload_account":
        window.location.href = '/';
        break;
      case true:
        if(divIds == 'frmExpertCompany' || divIds == 'frmExpertPersonal' || divIds == 'frmExpertPartner') {
          popupLink({
            elementId: 'popupLink',
          })
        } else {
          modalUpdate({
            button_id: 'jsTriggerModal',
            modal_id: 'modalUpdate',
            overlay_id: 'overplay',
            delay: true,
          });
        }
      default:
        break;
    }
  });
}

$("body").on("click", "#reloadPage", function (e) {
  e.preventDefault();
  location.reload();
  return false;
});

// Expert Update Profile
$("body").on("submit", "#frmExpertWithdrawal", function (pre) {
  pre.preventDefault();
  if(confirm(define.confirm_withdrawal) == true) {
    $("#frmExpertWithdrawal .errorTxt2").text('');
    let body_withdrawal = document.getElementById("body_withdrawal").value;
    let url = $(this).attr("action");
    let method = $(this).attr("method");
    let _token = $('meta[name="csrf-token"]').attr("content");
    let inputs = {};
    let input_serialized = $(this).serializeArray();
    input_serialized.forEach((field) => {
      inputs[field.name] = field.value;
    });
    return $.ajax({
      url: url,
      data: inputs,
      type: method,
      dataType: "json",
      beforeSend: function () {
        $("#frmExpertWithdrawal .btnSign02").attr("disabled", "disabled");
      },
    }).done(function (res) {
      $("#frmExpertWithdrawal .btnSign02").removeAttr("disabled");
      $("#frmExpertWithdrawal .errorTxt2").hide();
      if (res.status == "error") {
        $.each(res.message, function (key, value) {
          expertError.errorFields(key, value);
        });
      } else {
        if (res.status == true) {
          alert(res.message);
          location.reload();
        } else {
          alert(res.message);
        }
      }
    });
  }

  return false;
});

// Compnay Withdraw
$("body").on("submit", "#frmCompanyWithdrawal", function (pre) {
  pre.preventDefault();
  if(confirm(define.confirm_withdrawal) == true) {
    $("#frmCompanyWithdrawal .errorTxt2").text('');
    let body_withdrawal = document.getElementById("body_withdrawal").value;
    let url = $(this).attr("action");
    let method = $(this).attr("method");
    let _token = $('meta[name="csrf-token"]').attr("content");
    let inputs = {};
    let input_serialized = $(this).serializeArray();
    input_serialized.forEach((field) => {
      inputs[field.name] = field.value;
    });
    return $.ajax({
      url: url,
      data: inputs,
      type: method,
      dataType: "json",
      beforeSend: function () {
        $("#frmCompanyWithdrawal .btnSign02").attr("disabled", "disabled");
      },
    }).done(function (res) {
      $("#frmCompanyWithdrawal .btnSign02").removeAttr("disabled");
      $("#frmCompanyWithdrawal .errorTxt2").hide();
      if (res.status == "error") {
        $.each(res.message, function (key, value) {
          expertError.errorFields(key, value);
        });
      } else {
        alert(res.message);
        location.reload();
      }
    });
  }

  return false;
});

var list_filed = ['first_name', 'last_name', 'first_name_kana', 'last_name_kana', 'birthday_year', 'birthday_month', 'birthday_day', 'gender', 'password', 'confirm_password', 'phone0', 'phone1', 'phone2', 'job_status', 'main_achievement_url', 'business_number'];
function insertAdjacentHTMLDataPersonal(res)
{
  $(".blockForm").css('display', 'none');
  document.querySelector(".blockConfirm").insertAdjacentHTML("beforeend", res.html_confirm);
  $('#confirm_email').text($('#input_email').text());
}

function expertResetHideHtmlPersonal() {
  $("input").hide();
  $("select").hide();
  $(".radioGroup label").hide();
  $(".groupCol01 p").hide();
  $(".col1 span").hide();
  $(".col2 span").hide();
  $(".col3 span").hide();
  $(".groupCol p").hide();
  $("#jsBtnAddChildIdExport").css('display', 'none');
  $(".blockRadio1").css('display', 'none');
  $(".blockRadio2").css('display', 'none');
  $(".blockBtn").css('display', 'none');
  $("#buttonSave").css('display', 'block');
  $("#submit").val('done');
  if($("#submit").val() == 'confirm') {
    for (var k = 1; k <= 10; k++) {
      let company_name = document.querySelector("#show_company_name_"+k);
      if(company_name) {
        company_name.remove();
      }
    }
  }
  for (var i = 1; i <= 10; i++) {
    let company_name = document.querySelector("#show_company_name_"+i);
    if(company_name) {
      company_name.remove();
    }
  }
}

$("body").on("click", "#backFrmExpertPersonal", function (pre) {
  pre.preventDefault();
  $("input").show();
  $("select").show();
  $(".radioGroup label").show();
  $(".boxCol01 span").show();
  $(".groupCol p").show();
  $(".radioList").removeAttr("style");
  $(".groupCol01 p").removeAttr("style");
  $(".btnDelPlus").css('display', 'block');
  $("#buttonComfirm").css('display', 'block');
  $("#buttonSave").css('display', 'none');

  $(".blockInput1").removeAttr("style");
  $(".blockInput1 .group").removeAttr("style");

  $("#submit").val('confirm');
  $("#frmExpertPersonal .btnSign01").removeAttr("disabled");
  $(".blockBtn").css('display', 'block').removeAttr("style");
  $(".blockRadio1").removeAttr("style");
  $(".blockRadio2").removeAttr("style");
  $("#jsBtnAddChildIdExport").removeAttr("style");

  document.querySelectorAll('.confirm').forEach(el => el.remove());;
  $(".blockForm").css('display', 'block');
})


var list_filed_partner = ['first_name', 'last_name', 'first_name_kana', 'last_name_kana', 'birthday_year', 'birthday_month', 'birthday_day', 'gender', 'password', 'confirm_password', 'job_status', 'main_achievement_url'];

function insertAdjacentHTMLDataPartner(res)
{
  $(".blockForm").css('display', 'none');
  document.querySelector(".blockConfirm").insertAdjacentHTML("beforeend", res.html_confirm);
  $('#confirm_email').text($('#input_email').text());
}

function expertResetHideHtmlPartner() {
  $("input").hide();
  $("select").hide();
  $(".radioGroup label").hide();
  $(".groupCol01 p").hide();
  $(".col1 span").hide();
  $(".col2 span").hide();
  $(".col3 span").hide();
  $(".groupCol p").hide();
  $("#jsBtnAddChildIdExport").css('display', 'none');
  $(".blockRadio1").css('display', 'none');
  $(".blockRadio2").css('display', 'none');
  $(".blockBtn").css('display', 'none');
  $("#buttonSave").css('display', 'block');
  $("#submit").val('done');
  for (var i = 1; i <= 10; i++) {
    let company_name = document.querySelector("#show_company_name_"+i);
    if(company_name) {
      company_name.remove();
    }
  }
}

$("body").on("click", "#backFrmExpertPartner", function (pre) {
  pre.preventDefault();
  $("input").show();
  $("select").show();
  $(".radioGroup label").show();
  $(".boxCol01 span").show();
  $(".groupCol p").show();
  $(".radioList").removeAttr("style");
  $(".groupCol01 p").removeAttr("style");
  $(".btnDelPlus").css('display', 'block');
  $("#buttonComfirm").css('display', 'block');
  $("#buttonSave").css('display', 'none');

  $(".blockInput1").removeAttr("style");
  $(".blockInput1 .group").removeAttr("style");

  $("#submit").val('confirm');
  $("#backFrmExpertPartner .btnSign01").removeAttr("disabled");
  $(".blockBtn").css('display', 'block').removeAttr("style");
  $(".blockRadio1").removeAttr("style");
  $(".blockRadio2").removeAttr("style");
  $("#jsBtnAddChildIdExport").removeAttr("style");
  document.querySelectorAll('.confirm').forEach(el => el.remove());;
  $(".blockForm").css('display', 'block');
})

var list_filed_company = ['corporate_number', 'companies_name', 'company_name_kana', 'zip0', 'zip1', 'pref', 'city', 'address', 'building', 'phone0', 'phone1', 'phone2', 'director_name', 'owner_equity', 'url_corporate', 'business_number', 'first_name', 'last_name', 'first_name_kana', 'last_name_kana', 'birthday_year', 'birthday_month', 'birthday_day', 'gender', 'password', 'confirm_password', 'job_status', 'company_name', 'main_achievement_url'];
function insertAdjacentHTMLDataCompany(res)
{
  $(".input").css('display', 'none');
  $(res.html_confirm).insertAfter(".logoBox");
  $('#confirm_email').text($('#input_email').text());
}

$("body").on("click", "#backFrmExpertCompany", function (pre) {
  pre.preventDefault();
  $("input").removeAttr("style");
  $("select").removeAttr("style");
  $(".radioGroup label").show();
  $(".radioList").removeAttr("style");
  $(".groupCol01 p").removeAttr("style");

  $(".blockInput1").removeAttr("style");
  $(".blockInput1 .group").removeAttr("style");
  $("#data_zip0").removeAttr("style");
  $("#data_zip1").removeAttr("style");
  $("#data_zip2").removeAttr("style");
  $(".blockSelect1 .col1").removeAttr("style");
  $(".blockSelect1 .col2").removeAttr("style");
  $(".blockSelect1 .col3").removeAttr("style");
  $(".blockInput3 p").show();
  $("#jsBtnAddChildIdExport").removeAttr("style");
  $(".blockRadio2").removeAttr("style");

  $(".groupCol1 .col1").removeAttr("style");
  $(".groupCol1 .col2").removeAttr("style");

  $("#buttonComfirm").css('display', 'block');
  $("#buttonSave").css('display', 'none');
  $(".textError").css('display', 'none');
  $(".line").show();
  $("#submit").val('confirm');
  document.querySelectorAll('.confirm').forEach(el => el.remove());;
  $(".input").css('display', 'block');
  $(".blockBtn").removeAttr("style");
})

function expertResetHideHtmlCompany() {
  $("input").hide();
  $("select").hide();
  $(".radioGroup label").hide();
  $(".groupCol01 p").hide();
  $(".boxCol01 span").hide();
  $(".groupCol p").hide();
  $(".blockInput3 p").hide();
  $(".col1 span").hide();
  $(".col2 span").hide();
  $(".col3 span").hide();
  $(".line").hide();

  $("#jsBtnAddChildIdExport").css('display', 'none');
  $(".blockRadio2").css('display', 'none');
  $(".radioList").css('display', 'none');
  $("#buttonComfirm").css('display', 'none');
  $("#buttonSave").css('display', 'block');
  $("#submit").val('done');
  $(".blockRadio1").css('display', 'none');
  $(".blockBtn").css('display', 'none');
}

function handleResetModalInvitation() {
  if($("#divForm").length && $("#frmInviteDone").length){
    $("#divForm").css( "display", "block" );
    $("#frmInviteDone").css( "display", "none" );

    $("#divForm input[name='first_name']").val('');
    $("#divForm input[name='last_name']").val('');
    $("#divForm input[name='email']").val('');
    $("#divForm select[name='role']").val('');

    $("#divForm .first_name").removeClass('show');
    $("#divForm .last_name").removeClass('show');
    $("#divForm .email").removeClass('show');
  }
}

function popupCall() {
  let popupCallEls = document.querySelectorAll('.jsPopupCall'),
      popupCloseEls = document.querySelectorAll('.jsPopupClose'),
      selectList = document.querySelectorAll('.jsSelectPlaceholder');
  if (popupCallEls) {
      popupCallEls.forEach(popupCallEl => {
          popupCallEl.addEventListener('click', function(e) {
              e.preventDefault();
              handleResetModalInvitation();
              let popupEl = document.getElementById(popupCallEl.dataset.popup);
              if (popupEl) {
                  popupEl.classList.add('show');
                  document.documentElement.dataset.scroll = 'hidden';
                  popupEl.addEventListener('click', function name(e) {
                      if (e.target.id == popupCallEl.dataset.popup) {
                          popupEl.classList.remove('show');
                          document.documentElement.dataset.scroll = 'default';
                          if(selectList){
                            selectList.forEach(selectEle => {
                              selectEle.classList.remove('active');
                            })
                          }
                      }
                  });
              }
          });
      });
  }

  if (popupCloseEls.length > 0) {
      popupCloseEls.forEach(popupCloseEl => {
          popupCloseEl.addEventListener('click', function() {
              popupCloseEl.closest('.jsPopup').classList.remove('show');
              document.documentElement.dataset.scroll = 'default';
              if(selectList){
                selectList.forEach(selectEle => {
                  selectEle.classList.remove('active');
                })
              }
              handleResetModalInvitation();
          });
      });
  }
}

function browseFile() {
    let browseFileEl = document.getElementById('jsBrowseFile')
    if(browseFileEl) {
        browseFileEl.addEventListener('change', function() {
            browseFileEl.nextElementSibling.innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        });
    }
}

var val = '';
window.addEventListener('load', function() {
  popupCall();
  browseFile();
  myChangeRole(val);
});

window.myChangeRole = function(val) {
  if(val && val.value != undefined) {
    if(val.value > 0 && val.value <= 4) {
      if(confirm("本当に役職を変更してもよろしいですか。") == true) {
        let url = val.getAttribute('data-action');
        let _token = $('meta[name="csrf-token"]').attr("content");
        let inputs = {};
        inputs['id'] = val.getAttribute('data-id');
        inputs['role'] = val.value
        return $.ajax({
          url: url,
          data: inputs,
          type: 'POST',
          dataType: "json",
          beforeSend: function () {
          },
        }).done(function (res) {
          location.reload();
        });
      }
    } else {
      location.reload();
    }
  }
}
